<template>
    <x-page title="Observer">
        <template #header-actions>
            <x-create-button
                url="/admin/sms-observers/create"
                :disabled="isLoading"
                v-if="can('createSmsObservers')"
            />
        </template>

        <x-table
            :headers="['#', 'Nama', 'Deskripsi', 'Action']"
            :is-loading="isLoading"
        >
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link
                        :to="`/admin/sms-observers/${resource.id}`"
                        title="Klik untuk lihat detail"
                    >
                        {{ resource.label || "Untitled" }}
                    </router-link>
                </td>
                <td class="nowrap">
                    <span
                        v-html="$options.filters.nl2br(resource.description)"
                    />
                </td>
                <td>
                    <x-quick-edit-button
                        :url="`/admin/sms-observers/${resource.id}/edit`"
                        :disabled="isLoading"
                        v-if="can('updateSmsObservers')"
                    />
                    <x-quick-delete-button
                        @click="deleteResource(resource)"
                        :disabled="isLoading"
                        v-if="can('deleteSmsObservers')"
                    />
                </td>
            </tr>
        </x-table>

        <x-pagination
            v-if="shouldRenderPagination"
            :pagination="meta"
            :query="$route.query"
        />
    </x-page>
</template>

<script>
import XCreateButton from "../../components/XCreateButton.vue";
import XPage from "../../components/XPage.vue";
import XPagination from "../../components/XPagination.vue";
import XQuickActionButton from "../../components/XQuickActionButton.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import XQuickViewButton from "../../components/XQuickViewButton.vue";
import XTable from "../../components/XTable.vue";
import {
    deletePrompt,
    handleGeneralXhrError,
    warningPrompt,
} from "../../helpers";
import FilterableMixin from "../../mixins/FilterableMixin";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XCreateButton,
        XTable,
        XPage,
        XPagination,
        XQuickActionButton,
        XQuickViewButton,
        XQuickEditButton,
        XQuickDeleteButton,
    },
    created() {
        this.handleFilter().catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            isLoading: false,
            resources: [],
        };
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.label || "Observer",
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios
                        .delete(`/api/sms-observers/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: "success",
                                title: `Berhasil`,
                                text: `${
                                    resource.label || "Observer"
                                } dihapus!`,
                            });
                            this.fetchResources();
                        });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get("/api/sms-observers", {
                    params: route.query,
                })
                .then((response) => {
                    this.resources = response.data.data;
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                }),
            });
        },
        resetFilter() {
            this.handleFilter();
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
};
</script>
